import { render, staticRenderFns } from "./ShiftCalendar.vue?vue&type=template&id=edc94cca&scoped=true"
import script from "../../scripts/pages/ShiftCalendar.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/ShiftCalendar.js?vue&type=script&lang=js&external"
import style0 from "./ShiftCalendar.vue?vue&type=style&index=0&id=edc94cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc94cca",
  null
  
)

export default component.exports